import { render, staticRenderFns } from "./BillSla.vue?vue&type=template&id=6b4ce3ef"
import script from "./BillSla.vue?vue&type=script&lang=js"
export * from "./BillSla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports